module.exports = __webpack_public_path__ + "static/img/av_icon.150536e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/av_icon.png
// module id = 9bqj
// module chunks = 56